import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $investors,
  $totalCountOfInvestors,
  getInvestors,
  investorsMounted,
} from './model'
import { InvestorsRequest } from './types'

export const useInvestors = (strategyId: number) => {
  React.useEffect(() => {
    investorsMounted({
      strategyId: strategyId,
      limit: 10,
      page: 1,
      orderBy: 'startedAt',
      orderDirection: '-',
      searchText: {},
    })
  }, [])

  const onChangeInvestorsList = ({
    strategyId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: InvestorsRequest) => {
    investorsMounted({
      strategyId,
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  const loading = useStore(getInvestors.pending)

  const investors = useStore($investors)
  const totalCountOfInvestors = useStore($totalCountOfInvestors)
  return {
    investors,
    totalCountOfInvestors,
    loading,
    onChangeInvestorsList,
  }
}
